import {ColourMod} from "./LayoutEnums";

export enum avatarSize {
	ExtraSmall = 'avatar-xs',
	Small = 'avatar-sm',
	Medium = 'avatar-md',
	Large = 'avatar-lg',
	ExtraLarge = 'avatar-xl',
	FillHeight = 'avatar-fh',
}

export enum Directions {
	Start = 'start-direction',
	End = 'end-direction',
}

export enum ButtonType {
	Default,
	Input,
	Form,
	Custom,
}

export enum InputSize {
	Default = '',
	Small = 'input-small'
}

export enum ButtonSize {
	ExtraSmall = 'btn-tiny',
	Small = 'btn-small',
	Default = '',
	Large = 'btn-large',
}

export enum ModalSize {
	Default,
	Small,
	Large,
	ExtraLarge,
}

export enum CardLayoutType {
	Default,
	SlimHeader,
	Media,
}

export enum InputType {
	Default,
	Numbers,
	Email,
	Telephone,
	Select,
	MultiSelect,
	Textarea,
}

export enum InfoBoxLayout {
	Default = '',
	IconOffset = 'hint-icon-offset',
}

export enum ToggleType {
	Checkbox = 'checkbox',
	Radio = 'radio',
	Switch = 'switch',
}

export interface iActionLink {
	title: string;
	url?: string;
	target?: string;
	rel?: string;
	download?: boolean;
}

export interface iButtonLink extends iActionLink {
	colour?: ColourMod;
	icon?: any;
	iconOnly?: boolean;
}

export interface iOptionValue {
	label: string;
	value: string;
}
